import {Component, OnInit, ViewChild} from '@angular/core';
import {PageHeaderBarConfig, PageSubheaderBarConfig} from '../../../fw/pages/page-config-api';
import {BreadcrumService, BreadcrumStep } from '../../../fw/services/breadcrum.service';
import {AutoUnsubscribe} from '../../../fw/decoractors/AutoUnsubscribe';
import {FormBuilder, FormGroup} from "@angular/forms";
import {DynamicGridComponent} from "../../../fw/dynamic-grids/dynamic-grid.component";
import {ColumnDefinition} from "../../../fw/dynamic-grids/column-definition";
import {SharedService} from "../../shared/shared.service";
import {SharedDataService} from "../../shared/shared-data.service";
import {DtoManagementEmployee} from "./models/DtoManagementEmployee";
import {DtoBranchUser} from "../../shared/models/DtoBranchUser";
import {EmployeeInfoService} from "./employee-info.service";

@Component({
    selector: 'app-employee-info',
    template: require('./employee-info.component.html'),
    styles: [require('./employee-info.component.css')]
})

@AutoUnsubscribe()
export class EmployeeInfoComponent implements OnInit {
    @ViewChild('grid', {static: false}) grid: DynamicGridComponent;
    periodDisabled: boolean;
    data: DtoManagementEmployee[];
    filterHeaderConfig: PageHeaderBarConfig;
    periodItems: Array<{ text: string, value: number }> = [
        {text: "Deze week", value: 1},
        {text: "Deze maand", value: 2},
        {text: "Dit jaar", value: 3},
        {text: "Laatste 2 jaar", value: 4},
        {text: "Variabele periode", value: 5}
    ];
    branches: DtoBranchUser[];
    excelFilename: string;
    filterForm: FormGroup;
    pshbConfig: PageSubheaderBarConfig;

    columnDefinition: ColumnDefinition[] = [
        {
            key: 'name',
            label: 'Naam',
            type: 'string',
            width: '*'
        },
        {
            key: 'totalRetail',
            label: 'Totaal omzet',
            type: 'number',
            width: '160px',
            format: '{0:c2}'
        },
        {
            key: 'treatmentRetail',
            label: 'Behandelingen',
            type: 'number',
            width: '160',
            format: '{0:c2}'
        },
        {
            key: 'treatmentPercentage',
            label: '%',
            type: 'number',
            width: '80',
            format: '{0:p2}'
        },
        {
            key: 'articleRetail',
            label: 'Verkoop',
            type: 'number',
            width: '160',
            format: '{0:c2}'
        },
        {
            key: 'articlePercentage',
            label: '%',
            type: 'number',
            width: '80',
            format: '{0:p2}'
        },
        {
            key: 'treatmentAmount',
            label: 'Aantal behandelingen',
            type: 'number',
            width: '180px'
        },
        {
            key: 'articleAmount',
            label: 'Aantal verkoop',
            type: 'number',
            width: '180px'
        },
        {
            key: 'visits',
            label: 'Bezoeken',
            type: 'number',
            width: '120px'
        },
        {
            key: 'avarageRetail',
            label: 'Gemiddelde besteding',
            type: 'string',
            width: '180px',
            format: '{0:c2}'
        },
        {
            key: 'efficience',
            label: 'Werkbezetting',
            type: 'number',
            width: '120px'
        },
        {
            key: 'retailPerWorkhour',
            label: 'Omzet p/aanwezig uur',
            type: 'string',
            width: '180px',
            format: '{0:c2}'
        },
        {
            key: 'retailPerContracthour',
            label: 'Omzet p/contract uur',
            type: 'string',
            width: '190px',
            format: '{0:c2}'
        }
    ];

    constructor(private breadcrumService: BreadcrumService,
                private fb: FormBuilder,
                private ss: SharedService,
                private sds: SharedDataService,
                private ds: EmployeeInfoService) {
    }

    ngOnInit() {
        let steps: Array<BreadcrumStep> = [
            { text: 'hoofdmenu', isLastStep: false },
            { text: 'management', isLastStep: false },
            { text: 'detailgegevens medewerkers', isLastStep: true }];
        this.breadcrumService.setCurrentLocation(steps, true, 'home');
        this.filterHeaderConfig = {
            title: 'INSTELLINGEN',
            buttonDefinition: [
                {
                    description: 'RESULTATEN',
                    clickEventType: 'search',
                    isSmall: false
                }
            ]
        };

        this.filterForm = this.fb.group({
            userId: 0,
            periodId: 2,
            from: null,
            untill: null
        });


        this.filterForm.get('periodId').valueChanges.subscribe(newVal => {
            this.setFilterPeriod(newVal);
            this.loadData();
        });

        this.filterForm.get('userId').valueChanges.subscribe(newVal => {
            this.loadData();
        });

        this.filterForm.get('from').valueChanges.subscribe(newVal => {
            this.loadData();
        });

        this.filterForm.get('untill').valueChanges.subscribe(newVal => {
            this.loadData();
        });

        this.pshbConfig = {
            title: 'MEDEWERKERS',
            buttonDefinition: [
                {
                    clickEventType: 'excel',
                    description: 'EXCEL',
                    isSmall: false
                }
            ]
        };

        this.sds.getBranchesWithAll().subscribe((res: DtoBranchUser[]) => {
            this.branches = res;
            setTimeout(() => {
                this.setFilterPeriod(2);
                this.loadData();
            });
        });
    }

    clearData() {
        this.grid.clearData();
        this.data = null;
    }

    loadData() {
        this.excelFilename = `Detailgegevens medewerkers.xlsx`;
        this.clearData();
        this.ds.getEmployeeInfo({
            userId: this.filterForm.get('userId').value,
            from: this.filterForm.get('from').value,
            untill: this.filterForm.get('untill').value
        }).subscribe((res: DtoManagementEmployee[]) => {
            this.data = res;
            this.grid.showData(this.data);
        });
    }

    setFilterPeriod(periodKind: number) {
        if (periodKind == 1) {
            this.periodDisabled = true;
            this.filterForm.patchValue({ ['from']: this.ss.getFirstDayOfWeek(this.ss.getCurrentDate()) });
            this.filterForm.patchValue({ ['untill']: this.ss.addDaysToDate(this.ss.getFirstDayOfWeek(this.ss.getCurrentDate()), 6) });
        } else if (periodKind == 2) {
            this.periodDisabled = true;
            this.filterForm.patchValue({ ['from']: this.ss.getFirstDayOfMonth(this.ss.getCurrentDate()) });
            this.filterForm.patchValue({ ['untill']: this.ss.getLastDayOfMonth(this.ss.getCurrentDate()) });
        } else if (periodKind == 3) {
            this.periodDisabled = true;
            this.filterForm.patchValue({ ['from']: this.ss.getFirstDayOfYear(this.ss.getCurrentDate()) });
            this.filterForm.patchValue({ ['untill']: this.ss.getLastDayOfYear(this.ss.getCurrentDate()) });
        } else if (periodKind == 4) {
            this.periodDisabled = true;
            this.filterForm.patchValue({ ['from']: this.ss.getFirstDayOfYear(this.ss.getCurrentDate()) });
            this.filterForm.patchValue({ ['untill']: this.ss.addYearsToDate(this.ss.getLastDayOfYear(this.ss.getCurrentDate()), 1) });
        } else if (periodKind == 5) {
            this.periodDisabled = false;
        }
    }

    phbBtnClicked(event) {
        if (event == 'search') {
            this.loadData();
        }
    }

    pshbBtnClicked(event) {
        if (event == 'excel') {
            this.grid.saveAsExcel();
        }
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/app/management/employee-info/employee-info.component.ts